define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"underscore",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/reflection",
	"csi/table/New",
	"csi/xml",
	"./main",
	"./NewSupplierItemMixin",
	"Apparel/DesignatedSupplierMixin"
], function(array, declare, _, comm, PostRequest, locale, reflection, New, xml, Sourcing, NewSupplierItemMixin, DesignatedSupplierMixin) {

	const FACTORY = "Factory";

	const SUPPLIER = "Supplier";

	const SUPPLIERFACTORY = "SupplierFactory";

	return declare([NewSupplierItemMixin, DesignatedSupplierMixin], {
		quoteCntr: 0,

		//Flag to determine if style ColorAllocationStatus = WIP
		isAllocationWIP: false,

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			return this.inherited(arguments, [urlsNew.concat(this.urlNewItems)]);
		},

		getStringParameters: function() {
			// summary: use return value as parameter to success message
			return [this.quoteCntr];
		},

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd, /*Function*/filter) {
			// avoid duplication of colors / sizes
			fd = fd || this.m_formData; // in case form data isn't loaded yet

			fd.getFieldValue("Colors", true);
			fd.getFieldValue("ProductSizes", true);
			fd.getFieldValue(FACTORY, true);
			fd.getFieldValue(SUPPLIER, true);
			fd.getFieldValue("QuoteSRLineItem", true);

			this.inherited(arguments);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set the product and the default value for BOM on create form
			this.inherited(arguments);

			const product = this.m_cache.getParentOfType(this.getParent(), ["Style", "Material", "Food", "FormulatedMaterial"]);
			if (product) {
				//initialize designated supplier
				this.initializeDPSForQuotes(view, "Supplier", product);
				view.setProduct(product);
				view.addDefaultValue("QuoteBOM", product.AuthorityBOM);
			}
		},

		/**
		 * @override
		 * Ensure that parent product is in the cache from the ProductSourcing level
		 */
		onDependencyPaths: function(paths) {
			paths.push(xml.path(xml.ATTR_PARENT));
		},

		onValidate() {
			// summary: create quotes according to form and add to source
			var fd = this.m_formData;
			var form = this.popupView;
			var cache = this.m_cache;
			var lineItems = fd.getFieldValue("QuoteSRLineItem", true);

			const isSupplierFactory = this.isCreationLevelSupplierFactory();
			// If Style.ColorAllocationStatus == Allocation WIP then Supplier/Factory fields would be single select
			//	so, if getting a single value, put in list for request to go through
			const sourcesField = isSupplierFactory ? fd.getField(FACTORY, true) : fd.getField(SUPPLIER, true);
			let sources;
			if (sourcesField.getType() === xml.ATTR_REF) {
				sources = isSupplierFactory ? [fd.getFieldValue(FACTORY, true)] : [fd.getFieldValue(SUPPLIER, true)];
			} else {
				sources = isSupplierFactory ? fd.getFieldValue(FACTORY, true) : fd.getFieldValue(SUPPLIER, true);
			}

			var nodeName = fd.getFieldValue(xml.ATTR_NAME, true);
			var urlParent = this.widget.getViewURL();
			const rc = reflection.getClass(cache.getNode(urlParent).$Type);
			const productSourcingNode = rc.isDerivedFrom("ProductSourcing") && cache.getNode(urlParent);
			const supplierRequestNode = cache.getNode(urlParent).$Type == "SupplierRequest" && cache.getNode(urlParent);
			// bProduct is true for Product SupplierRequests, false for FormulatedProduct SupplierRequests
			const bProduct = supplierRequestNode ? (supplierRequestNode.RequestType == "DataPackageContainerType:Style" || supplierRequestNode.RequestType == "DataPackageContainerType:Material") : productSourcingNode != null;
			var supplierItemDimValue = fd.getFieldValue("SupplierItemDimensions", true) || 0;
			var bColors = bProduct ? (supplierItemDimValue != 0) : false;
			var isQuotePerActiveColor = bProduct ? supplierItemDimValue == form.getQuotePerActiveColor() : false;
			var w = this.m_writer;
			var self = this;
			var newSources = {};
			this.urlNewItems = [];

			this.m_action.setReturnParameters();

			function creator(srcURL, lineItemURL) {
				const templateURL = fd.getFieldValue("SupplierItemTemplate", true) || fd.getFieldValue("FoodSupplierItemTemplate", true);
				let supplierItemURL = null;

				// TODO: these sync requests are a temporary fix for C8-28603 / 29391. The logic should be refactored using the custom action framework
				let productSourcingNode;
				if (lineItemURL == null) {
					productSourcingNode = self.widget.getViewNode();
				} else {
					const srLineItemProduct = cache.getNode(cache.getNode(lineItemURL).SRLineItemProduct);
					if (srLineItemProduct.$Type === "FoodSKU") {
						const food = cache.getNode(srLineItemProduct["__Parent__"], true);
						productSourcingNode = cache.getNode(food.ProductSourcing, true);
					} else {
						productSourcingNode = cache.getNode(srLineItemProduct.ProductSourcing, true);
					}
				}

				const productSources = cache.getNodes(productSourcingNode.ProductSources);
				const productSource = productSources.filter((ps) => !!ps).find((ps) => isSupplierFactory ? ps.SupplierFactory === srcURL : ps.Supplier === srcURL);
				let sourceURL = null;

				if (!productSource) {
					// see if we really need to create this node, or if we had just created it and can just look it up
					const key = productSourcingNode.$URL + "," + srcURL;
					const mappedSourceURL = newSources[key];
					if (mappedSourceURL) {
						sourceURL = mappedSourceURL;
					} else {
						sourceURL = comm.createUrl();
						let cnSrc;
						if (bProduct) {
							cnSrc = w.createNode(sourceURL, "ProductSource"); // changeNode for source
						} else {
							cnSrc = w.createNode(sourceURL, "FoodSource"); // changeNode for source
						}

						// look up supplier agent
						const supplier = cache.getNode(srcURL);
						if (xml.isValidURL(supplier.Agent)) {
							cnSrc.changeAttribute("Agent", xml.ATTR_REF, supplier.Agent);
						} else if (supplier.AllAgents != null && supplier.AllAgents.length == 1) {
							cnSrc.changeAttribute("Agent", xml.ATTR_REF, supplier.AllAgents[0]);
						}

						if(isSupplierFactory) {
							cnSrc.changeAttribute(SUPPLIERFACTORY, xml.ATTR_REF, srcURL);
							cnSrc.changeAttribute(SUPPLIER, xml.ATTR_REF, supplier.__Parent__);
						} else {
							cnSrc.changeAttribute(SUPPLIER, xml.ATTR_REF, srcURL);
						}
						cnSrc.attach(productSourcingNode.$URL, "ProductSources");

						newSources[key] = sourceURL;
					}
				} else {
					sourceURL = productSource.$URL;
				}

				// create new SupplierItem node
				supplierItemURL = comm.createUrl();

				// if using a template, just copy it. o/w create a fresh SupplierItem node
				let cnSI = null; // changeNode for supplier item
				if (xml.isValidURL(templateURL)) {
					if (bProduct) {
						w.callMethod("Apparel", "BasicCopySupplierItem")
							.addParameter(xml.PROP_URL, xml.ATTR_REF, supplierItemURL)
							.addParameter(xml.PROP_URL_FROM, xml.ATTR_REF, templateURL);
					} else {
						w.callMethod("FormulatedProduct", "BasicCopyFoodSupplierItem")
							.addParameter(xml.PROP_URL, xml.ATTR_REF, supplierItemURL)
							.addParameter(xml.PROP_URL_FROM, xml.ATTR_REF, templateURL);
					}

					cnSI = w.changeNode(supplierItemURL);
				} else {
					if (bProduct) {
						cnSI = w.createNode(supplierItemURL, "SupplierItem");
					} else {
						cnSI = w.createNode(supplierItemURL, "FoodSupplierItem");
					}

				}

				cnSI.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, nodeName);
				cnSI.changeAttribute("QuoteSRLineItem", xml.ATTR_REF, lineItemURL);

				// tie the Source
				cnSI.attach(sourceURL, "SupplierItems");

				return supplierItemURL;
			}

			var items = _.map(lineItems, function(url) {
				var lineItem = cache.getNode(url);
				var srLineItemProduct = lineItem ? lineItem.SRLineItemProduct : null;
				return {lineitem: url, product: srLineItemProduct};
			});

			if (items.length === 0) {
				items.push({product: fd.getParent().__Parent__});
			}

			const req = new PostRequest(comm.MOD_SEARCH, comm.OP_URL, {"Qry.URL": _.union(sources, lineItems)}).addDependencyPaths(["Child:SRLineItemProduct/Child:ProductColors", "Child:SRLineItemProduct/Child:ProductType/Child:ProductionConfig", "Child:Factory", "Child:SRLIProductSources/Child:__Parent__/Child:ProductSources"]);

			const {getColorwaysForProductWithAllocationStatusWIP} = this;
			return req.post().then(
				function(res) {
					cache.cacheResponse(res);

					_.each(items, function(item) {
						var colors;
						var product;

						if (bColors) {
							var lineitem = cache.getNode(item.lineitem);
							if (lineitem && isQuotePerActiveColor) {
								product = lineitem.SRLineItemProduct;
								const productNode = cache.getNode(product);
								this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(productNode);
								if (this.isAllocationWIP) {
									colors = getColorwaysForProductWithAllocationStatusWIP(productNode, cache, fd);

								} else if (!this.isAllocationWIP) {
									colors = _.filter(cache.getChildren(productNode, "ProductColors"), function(c) {return c.Active;});
								}
								fd.colorSizePairs = _.map(colors, function(color) {return {c: color, sources: null};});
							} else {
								fd.colorSizePairs = form.getSelectedColorSizePairs();
							}
						}

						_.each(sources, function(srcURL) {
							var newColors = 0;
							if (colors && colors.length > 0) {
								newColors = colors.length;
							} else {
								// see if we are on None or Quote per active Color
								newColors = (fd.colorSizePairs && fd.colorSizePairs.length > 0) ? fd.colorSizePairs.length : (bColors ? 0 : 1);
							}

							if (newColors > 0) {
								self.quoteCntr += newColors;

								const factory = cache.getNode(srcURL)?.Factory;
								const supplierOrFactoryName = isSupplierFactory ? cache.getNode(factory).$Name : cache.getNode(srcURL).$Name;

								var urlNewItemsSuppl = self.createSupplierItems(self.m_writer, fd, function() {
									return creator(srcURL, item.lineitem);
								}, srcURL, supplierOrFactoryName, item);

								_.each(urlNewItemsSuppl, function(URL) {
									self.urlNewItems.push(URL);
								});
							}
						}, this);
					}, this);
				}
			);
		},

		process: function() {
			this.publish();
		},

		postProcessSuccess: function() {
			if (this.quoteCntr <= this.widget.querySize) {
				this._newPostProcess();
			} else {
				this.widget.refreshData();
			}
		},

		/**
		 * @override
		 * Reset counter if there is an error
		 */
		displayError: function(error) {
			this.inherited(arguments);
			this.quoteCntr = 0;
		},

		_canNavigate: function() {
			// summary: disable Save & Go since action can create multiple supplier items
			return false;
		},

		// If product has ColorAllocationStatus = WIP and QuotePerActiveColor option is true
		// return the colors from the sources selected that include the colorway in the Source's ColorProductSources  
		getColorwaysForProductWithAllocationStatusWIP: function(productNode, cache, fd){
			const isFDDEnabled = Sourcing.isFDDEnabled(productNode, cache);
			const sourcesFieldValue = isFDDEnabled ? fd.getFieldValue(FACTORY, true) : fd.getFieldValue(SUPPLIER, true);
			let supplierOrFactoryMatchingList = [];
			let colors = array.filter(cache.getChildren(productNode, "ProductColors"), function(c) {
				let colorProductSourceUrlList = c.ColorwayColorSources;
				supplierOrFactoryMatchingList = colorProductSourceUrlList.filter(cpsUrl => {
					// get matching ProductSource from ColorProductSource
					let cps = cache.getNode(cpsUrl);
					let productSource = cache.getNode(cps.__Parent__);
					// return if ProductSource supplier/factory === supplier/factory value on form
					let supplierOrFactory = isFDDEnabled ? productSource.SupplierFactory : productSource.Supplier;
					return sourcesFieldValue.includes(supplierOrFactory) && cps.Active;
				})
				return c.Active && supplierOrFactoryMatchingList.length;
			});
			return colors;
		},
	});
});
